import { Link } from 'react-router-dom';
const NavigateToTestingRoute = ({ path }: { path: string }) => (
  <div>
    Please <Link to={path}>click here</Link> for your aplication to render
  </div>
);

export default NavigateToTestingRoute;
